export default __webpack_public_path__ + "static/media/disco@3x.eedd74ae.png";